var _g, _g2, _g3, _g4, _g5, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoUpOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 130,
    viewBox: "0 0 145 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.286 -29.7698C92.0839 -19.8682 82.6283 -10.1059 74.2623 0.400281C65.9859 10.9551 58.6025 22.0038 52.4818 33.7195C46.2831 45.3902 41.2145 57.6621 37.2263 70.4711C33.2594 83.3156 30.4942 96.6105 27.9634 110.619C24.2618 96.83 23.7709 82.2023 25.8282 67.9081C27.9108 53.6208 32.3463 39.5216 39.2512 26.7055C45.976 13.7854 55.1754 2.24907 65.7637 -7.55537C76.4157 -17.3012 88.7916 -25.125 102.286 -29.7698Z",
    fill: "url(#paint0_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.204 -8.10485C103.784 0.907652 96.6683 9.33158 90.3417 18.1445C84.0175 26.9774 78.4492 36.1413 73.3972 45.5413C68.4911 55.0162 63.9694 64.7301 60.3039 74.9585C56.5262 85.1717 53.5181 95.7487 50.1643 106.946C44.5307 84.1534 49.2457 59.4458 60.1689 38.5208C71.3388 17.7538 89.149 -0.0706283 111.204 -8.10485Z",
    fill: "url(#paint1_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.179 12.7578C116.183 20.7611 111.108 27.8503 106.614 35.1981C102.039 42.4755 97.7342 49.7011 93.8453 57.1592C89.9056 64.5895 86.2853 72.181 82.8888 80.0722C79.3375 87.9361 76.3515 96.1123 72.468 104.731C70.0997 95.5626 70.089 86.0422 71.5818 76.7822C73.0903 67.5111 76.1704 58.4684 80.6134 50.1475C84.991 41.792 90.7932 34.2016 97.568 27.7214C104.402 21.2803 112.248 15.9175 121.179 12.7578Z",
    fill: "url(#paint2_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.181 34.9536C128.04 41.8599 124.692 46.958 122.086 52.5668L113.808 68.4856L105.348 84.3116C102.355 89.6674 99.4051 95.1641 95.3092 100.911C93.2124 94.1417 93.2338 87.2826 94.174 80.5959C95.2224 73.9314 97.4204 67.461 100.566 61.4943C103.696 55.5171 107.845 50.0797 112.751 45.4534C117.626 40.8 123.732 37.3451 130.181 34.9536Z",
    fill: "url(#paint3_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.864 55.2742C138.567 65.1834 135.673 72.0872 132.202 78.9527C130.433 82.3432 128.41 85.5945 126.016 88.8511C123.536 92.0883 120.886 95.3591 116.87 98.6267C114.794 93.8538 114.571 89.2005 114.998 84.6944C115.508 80.2084 116.873 75.8982 118.955 71.9696C121.032 68.0383 123.81 64.4709 127.226 61.5125C130.736 58.6409 134.616 56.1193 139.864 55.2742Z",
    fill: "url(#paint4_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.999 74.2608C152.099 77.9606 152.149 80.6015 151.998 83.0407C151.773 85.4233 151.169 87.4601 150.198 89.2993C149.23 91.1399 147.876 92.7684 146.031 94.2791C144.102 95.7637 141.88 97.1837 138.187 98.3471C135.936 95.1749 135.342 92.3228 135.219 89.6102C135.179 86.9255 135.807 84.4349 136.989 82.2463C138.166 80.0538 139.88 78.151 142.127 76.6921C144.448 75.2918 147.126 74.192 150.999 74.2608Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.9817,
    y1: 102.547,
    x2: 93.3526,
    y2: -34.9278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.0789,
    y1: 100.546,
    x2: 104.157,
    y2: -12.1733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 63.6746,
    y1: 99.6545,
    x2: 115.678,
    y2: 9.58177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 88.9359,
    y1: 97.2311,
    x2: 126.214,
    y2: 32.6634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 113.389,
    y1: 96.6167,
    x2: 137.909,
    y2: 54.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 136.799,
    y1: 97.5458,
    x2: 150.432,
    y2: 73.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37658"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpOrange);
export default __webpack_public_path__ + "static/media/LogoUpOrange.eb43b93a0a0952d3561e2edffb625f86.svg";
export { ForwardRef as ReactComponent };